import { render, staticRenderFns } from "./AnchorBarModule.vue?vue&type=template&id=6a72fcd9&"
import script from "./AnchorBarModule.ts?vue&type=script&lang=ts&"
export * from "./AnchorBarModule.ts?vue&type=script&lang=ts&"
import style0 from "./AnchorBarModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports